








































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { ShakenShohiyou } from "@/model/shakenShohiyou";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import { UserService } from "@/service/UserService";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ButtonInspectResult from "@/components/common/button/ButtonInspectResult.vue";
import Number from "@/shared/filters/Number.ts";

export interface SideTab {
  isActive?: boolean;
  isConfirm?: boolean;
}

@Component({
  components: {
    appInputNumber: InputNumber
  },
  filters: {
    Number
  }
})
export default class QuickSideTabRight extends Vue {
  // @Prop() totalRecommend: any;
  @Prop() totalCoupon: any;
  @Prop() totalShohiyou: any;
  @Prop() selectTabNum: number;

  totalRecommend: any = { totalZk: 0, totalZn: 0 };
  // totalShohiyou: any = { totalZk: 0, totalZn: 0 };
  // totalCoupon: any = { subTotalZk: 0, subTotalZn: 0 };
  stateId: number = 1;
  isConfirmRecommend: number = 0;
  isConfirmPayment: number = 0;
  isConfirmShohiyou: number = 0;

  sideTab: SideTab[] = [
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    },
    {
      isActive: false,
      isConfirm: false
    }
  ];

  sumLegal56: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  sumRecommend: any = {
    totalZk: 0,
    totalZn: 0,
    isConfirm: 0
  };

  hasBtn: boolean = false;

  isOnPlus = [false, false, false, false];

  @Watch('selectTabNum')
  onChangeSelectTab() {
    this.onActive(this.selectTabNum);
  }

  created() {
    console.log("QuickSideTabRight.created => START!!", this.totalCoupon);
    if (this.$route.name == "userquickmitsumori") {
      this.hasBtn = false;
    } else {
      this.hasBtn = true;
    }
  }

  setSumRecommend() {
    // this.$set(this, "sumRecommend", this.sumPrice(INSPECT_TYPE.RECOMMEND));
  }

  get sum() {
    return (
      +this.totalShohiyou.totalZk +
      +this.totalCoupon.subTotalZk +
      +this.totalRecommend.totalZk
    );
  }

  get sumZn() {
    return (
      +this.totalShohiyou.totalZn +
      +this.totalCoupon.subTotalZn +
      +this.totalRecommend.totalZn
    );
  }

  onActive(num: number) {
    this.sideTab[num].isActive = true;
    this.sideTab.forEach((tab: any, i: number) => {
      if (i != num) {
        tab.isActive = false;
      }
    });
  }

  onSelect(num: number) {
    this.onActive(num);
    if (num == 0) {
      this.$router.push({ name: "userinspectioncost" });
    } else if (num == 1) {
       this.$router.push({ name: "quickdiscountcoupon" });
    // } else if (num == 2) {
    //   this.$router.push({ name: "userrecommend" });
    // } else if (num == 3) {
    //   this.$router.push({ name: "paymentdetail" });
    }
  }

  onConfirm(index: number) {
    this.sideTab[index].isConfirm = true;
    this.onUpdate(index);
  }

  onUpdate(index: number) {
    // if (index == 2) {
    //   this.setSumPriceLegal56();
    // } else if (index == 3) {
    //   this.setSumRecommend();
    // }
  }

  isConfirm(flag: number) {
    return flag == 1;
  }

  textConfirm(flag: number) {
    return flag ? "確" : "未";
  }

  onPlus(index: number, event: any) {
    event.stopPropagation();
    this.$set(this.isOnPlus, index, !this.isOnPlus[index]);
  }

  gotoMitusmori() {
    this.$router.push({ name: "userquickmitsumori" });
  }

  get isActiveInspectCost() {
    return this.sideTab[0].isActive;
  }
}
